var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLouisiana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.31,226.191h-12.709l-8.74-7.547l5.166-11.121h6.749l3.182-7.945l-3.182-5.561l-0.395-4.369 c0,0-9.135,3.177-9.931,11.52l-7.15-0.396l-3.177-5.164l9.929-12.314l-3.574-14.3l-8.736-7.546l2.778-18.272l-85.001,3.973 l0.793-24.629c0,0,21.844-37.336,23.434-48.061l-6.354-7.945l1.191-5.561l-5.063-10.724l1.884-10.725L24.764,42.687l1.925,54.015 c5.958,5.229,9.533,21.25,9.533,21.25s12.512,19.662,12.512,28.601c0,8.937-8.938,26.811-8.938,26.811l4.767,5.957l-5.958,38.132 c0,0,15.691-3.972,23.634-3.177c7.945,0.794,38.528,12.313,47.268,11.52c8.74-0.795,10.725,0.04,10.725,0.04s9.93,4.726,11.52,2.74 c1.588-1.986-4.766-9.532-4.766-9.532l-7.15,2.572c0,0-8.341-4.77-1.589-7.445s16.284-1.295,19.86,0 c3.574,1.297,7.547,10.434,7.547,10.434s8.739-0.795,11.122,1.588c2.383,2.384,0,10.327,0,10.327s15.092,9.532,24.229,11.122 c9.137,1.59,9.137-8.342,9.137-8.342l11.519-5.957c0,0,7.149,8.34,4.367,11.52c-2.778,3.178,13.108-3.974,8.342-17.479 c0,0,5.165,0.797,7.548-5.561l1.985,10.327c0,0,19.861,3.575,22.244,7.548c0.342,0.565,0.574,0.982,0.742,1.302l9.983,1.479 l5.56-9.136L251.31,226.191z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLouisiana);
export default __webpack_public_path__ + "static/media/louisiana.e0ed39dfb525c886ba4c1646001addea.svg";
export { ForwardRef as ReactComponent };